<div class="background-sura">
  <div class="container pl-0 pr-0">
    <div style="padding: 10px 0px"></div>
    <form class="container-fluid" [formGroup]="uduarioForm" autocomplete="off">
      <div class="row">
        <div class="col-xs-12 col-lg-6 col-md-6">
          <div class="row">
            <div class="binfo">
              <div class="form-group ">
                <mat-form-field class="col-lg-12 padding-left-0" appearance="outline">
                  <mat-label class="col-form-label">USUARIO</mat-label>
                  <input matInput type="text" name="usuario" (keypress)="fnKeyDownAlphaNumeric($event)"
                         (keyup)="fnAlphaNumericMobile($event)" (input)="fnInputMaxLength($event);"
                         formControlName="usuario"
                         maxlength="15">
                  <mat-error *ngIf="hasError('usuario')">{{obtenerMensajeError("usuario")}}</mat-error>
                </mat-form-field>
              </div>
              <div class="form-group ">
                <mat-form-field class="col-lg-12 padding-left-0" appearance="outline">
                  <mat-label class="col-form-label">CONTRASE&Ntilde;A</mat-label>
                  <input matInput name="clave" formControlName="clave" [type]="hide ? 'password' : 'text'">
                  <mat-error *ngIf="hasError('usuario')">{{obtenerMensajeError("usuario")}}</mat-error>
                  <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </mat-form-field>
              </div>
              <div style="z-index:99999">
                <re-captcha
                  #captchaRef="reCaptcha"
                  (resolved)="resolved($event)"
                  siteKey="6LeTf68UAAAAAKEsJuKUhGHbuL343q9zkajYZ5AS"
                  size="invisible" style="z-index:99999; position: fixed;"></re-captcha>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group position-center  margin-bottom-50">
              <button mat-raised-button color="primary" (click)="onLoginClick(captchaRef)">INGRESAR</button>
            </div>
          </div>
        </div>
        <div id="logo" class="col-xs-12 col-lg-6 col-md-6" style="
    text-align: right;">
          <img src="../../../assets/banner-fg.png" alt="banner-fg-sura" height="400px">
        </div>
      </div>
    </form>
  </div>
</div>
